import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import {
  defaultLineItemsTotal,
  MONTHS_KEYS,
  SPEND_TYPES,
} from '../../../../../../framework/constants/spend.constants';
import { SpendCustomInputComponent } from '../../../../../../framework/inputs/spend-custom-input/spend-custom-input.component';
import { ILineItemsTotal } from '../../../../../../store/spend/spend.interfaces';
import { templateSelectors } from '../../../../../../store/templates/templates.selectors';
import { Store } from '@ngrx/store';
import {
  selectHasCommitments,
  selectLineItemTotals,
} from '../../../../../../store/spend/spend.selectors';
import { addDefaultLineItem } from '../../../../../../store/spend/spend.actions';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TooltipDirective } from '@app/directives/tooltip.directive';
import { CurrentUserService } from '../../../../../../services/current-user.service';

@Component({
  selector: 'app-budget-line-item-totals',
  imports: [AsyncPipe, NgClass, SpendCustomInputComponent, TooltipDirective],
  templateUrl: './budget-line-item-totals.component.html',
  styleUrl: 'budget-line-item-totals.component.scss',
})
export class BudgetLineItemTotalsComponent implements OnInit, OnDestroy {
  protected readonly store = inject(Store);
  protected readonly userService = inject(CurrentUserService);

  @Input({ required: true }) selectedBudgetType: SPEND_TYPES;
  @Input({ required: true }) hideTotals: boolean;

  protected readonly MONTHS_KEYS = MONTHS_KEYS;
  protected readonly SPEND_TYPES = SPEND_TYPES;

  protected readonly areTemplatesLoading$ = this.store.select(templateSelectors.getIsLoading);
  protected readonly isDestroyed$ = new Subject<boolean>();
  protected readonly totalLineItems$ = this.store.select(selectLineItemTotals);
  protected readonly hasCommitments$ = this.store.select(selectHasCommitments);
  protected totals: ILineItemsTotal = defaultLineItemsTotal;

  addLineToStore() {
    console.log('addLineToStore');
    this.store.dispatch(addDefaultLineItem());
  }

  ngOnDestroy(): void {
    this.isDestroyed$.next(true);
    this.isDestroyed$.complete();
  }

  ngOnInit(): void {
    this.totalLineItems$.pipe(takeUntil(this.isDestroyed$)).subscribe((totals) => {
      this.totals = totals;
    });
  }
}
